import { Paper, Step, StepLabel, Stepper } from "@mui/material";

type DrawStepperProps = {
  steps: string[];
  activeStep: number;
};

const DrawStepper: React.FC<DrawStepperProps> = ({ steps, activeStep }) => {
  return (
          <Paper sx={{ p: 3, mb: 4 }}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label, index) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Paper>
  );
};

export default DrawStepper;